import { render, staticRenderFns } from "./ProjectListHeaderItem.vue?vue&type=template&id=a259a922&scoped=true&"
import script from "./ProjectListHeaderItem.vue?vue&type=script&lang=js&"
export * from "./ProjectListHeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListHeaderItem.vue?vue&type=style&index=0&id=a259a922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a259a922",
  null
  
)

export default component.exports